import React, { useEffect, useState } from 'react'
import images from '../../assets/images/constantImages';
import { useDispatch, useSelector } from 'react-redux';
import { getStoresDetails } from './StoreSlice';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import icons from '../../assets/images/constantIcons';

const Navbar = ({ cartCount }) => {
  const dispatch = useDispatch();
  const storeId = localStorage.getItem('selectedStoreId');
  const [isLogOutOpen, setIsLogOutOpen] = useState(false);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const hasToken = () => !!localStorage.getItem("canteenToken");
  const userName = localStorage.getItem("fullname");

  // Fetch stores again on refresh
  useEffect(() => {
    dispatch(getStoresDetails());
  }, [dispatch]);


  const { data: stores } = useSelector((state) => state.store);
  const selectedStore = stores.find((store) => store.vendor_id === Number(storeId));

  const handleLogout = () => {
    setIsSubmitting(true)
    // Remove user data from local storage
    localStorage.removeItem("selectedStoreId");
    localStorage.removeItem("canteenId");
    localStorage.removeItem("canteenToken");
    localStorage.removeItem("canteen_user_id");
    localStorage.removeItem("cart");
    localStorage.removeItem("canteenUserName");
    localStorage.removeItem("userName");

    // Show logout success message
    toast.success("Logged out successfully!", { duration: 1000 });

    setIsSubmitting(false);
    navigate("/menuScanner");
  };
  return (
    <div className='relative'>
        <div style={{boxShadow:" 0 4px 6px -1px rgba(0, 0, 0, 0.1)"}} className='absolute bottom-1 w-full shadow-2xl h-1'></div>
      <div className="h-[12vh] flex justify-between items-center px-5 md:px-10 py-7 bg-white " >
        <div>
          {selectedStore?.store_logo && (
            <img
              src={selectedStore.store_logo }
              alt="Store logo"
              className="mx-auto w-44 h-14"
            />
          )}
        </div>
        {hasToken() ? (

          <>
            <div className="flex justify-end gap-5 items-center">
              {/* Notification Bell */}
              <div
                className="w-[38px] h-[38px] s:w-[48px] s:h-[48px] rounded-full bg-canteencardcolor flex justify-center items-center cursor-pointer"
              >
                <icons.IoMdNotificationsOutline  className='text-G500 text-3xl'/>
              </div>

              {/* Profile Info */}
              <div className="flex flex-col lg:flex-row gap-1 md:gap-2 justify-center items-center">
                <img
                  src={images.defaultprofilepicture}
                  alt="Profile"
                  loading="lazy"
                  className="object-cover w-[38px] h-[38px] s:w-[48px] s:h-[48px] rounded-full"
                />
                <h1 className="text-[10px] md:text-[14px] font-medium text-Grey700">
                  {userName}
                </h1>
              </div>
              {/* <div className="w-[38px] h-[38px] s:w-[48px] s:h-[48px] rounded-full flex justify-center items-center relative">
                <Link to="/cartOrders">
                  <icons.PiShoppingCart className="text-2xl text-green" />
                </Link>
                <p className='bg-emerald-300 text-white font-bold w-6 h-4 rounded-full flex justify-center items-center absolute top-1 py-1 right-1'>{cartCount} </p>
              </div> */}
              {/* Logout Button */}
              <div
                onClick={() => setIsLogOutOpen(true)}
                className="w-[38px] h-[38px] s:w-[48px] s:h-[48px] rounded-full bg-canteencardcolor flex justify-center items-center cursor-pointer"
              >
                <icons.MdLogout  className='text-G500 text-2xl'/>
              </div>
            </div>

          </>
        ) : (
          <div>
            <img
              src={images.defaultprofilepicture}
              alt="Profile"
              loading="lazy"
              className="object-cover w-[38px] h-[38px] s:w-[48px] s:h-[48px] rounded-full"
            />

          </div>
        )}

      </div>

      {/* Logout Confirmation Modal */}
      {isLogOutOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
            <h2 className="text-xl font-semibold mb-5 text-G500 text-center">
              Are you sure you want to log out?
            </h2>

            {/* Buttons */}
            <div className="flex justify-center space-x-4 mt-14">
              <button
                type="button"
                onClick={() => setIsLogOutOpen(false)}
                className="w-[75px] sm:w-[93px] py-2 text-sm text-center bg-white text-green rounded-lg border border-green"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                disabled={isSubmitting}
                className={`w-[75px] sm:w-[93px] py-2 text-sm text-center rounded-lg ${isSubmitting
                  ? "bg-green50 cursor-not-allowed"
                  : "bg-canteengreen text-white"
                  }`}
              >
                {isSubmitting ? "Logging out..." : "Log Out"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Navbar;